// extracted by mini-css-extract-plugin
export default {"flags":"FlagFromPhoneNumber_flags__ccQm9"};